import React from 'react';
import TableBoolean from '../../components/Table/TableBoolean/TableBoolean';

const headerStyle = () => {
    return { borderColor: '#a81933' };
};

const columnStyle = () => {
    return {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    };
};

export const columns = [
    {    
        dataField: 'name',
        text: 'Name',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle
    },
    {
        dataField: 'statusName',
        text: 'Status',
        sort: true,
        formatter: (_cell, row) => <TableBoolean value={row.statusName == 'Active' ? true : false} text={row.statusName} />,
        headerStyle: () => { return { width: '100px', ...headerStyle() }; }
    }
];
    
export const sorting = [{
    dataField: 'name',
    order: 'asc'
}];